import RequestBase from "./RequestBase.ts";

export default class PlayerInGameRoles extends RequestBase {
    constructor(){
        super("PlayerInGameRole/");
    }

    GetForGroup = (groupId, onSuccess) => {
        this.defaultAxios.get(`GetForGroup/${groupId}`)
        .then((res) => 
        {
            onSuccess(res.data);
        })
    };
}
